export const listByAttributeName = (list, fieldName = 'name') => {
  if (!list) return {}
  const result = {}
  for (const element of list) {
    result[element[fieldName]] = element
  }
  return result
}
